import { Section, Eyebrow, ChromeHeading, GoldText } from "../funnel";
import { DariusBlock } from "./DariusBlock";

export const Circle = () => (
  <Section data-testid="circle-section">
    <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
      <div>
        <Eyebrow>THE COMPANY I KEEP</Eyebrow>
        <ChromeHeading className="mt-4 text-4xl sm:text-5xl lg:text-6xl">
          Show me your circle, <GoldText>and I'll show you your future.</GoldText>
        </ChromeHeading>
        <p className="mt-6 text-[16px] leading-relaxed text-[#cfc7b6]">The rooms you're in shape what you believe is possible. I make it a point to be around people who are building, and that's the standard I'm building Educate II Elevate on.</p>
        <p className="font-serif-it mt-6 text-2xl leading-snug text-[#f4efe4]">Your network is your net worth. Your circle is your ceiling.</p>
      </div>
      <figure className="mx-auto w-full max-w-[520px] pr-3">
        <img src="/assets/circle-event.jpg" alt="Jay Shelton with Dion, Smitty and Darius at an inner circle event" className="gold-frame aspect-square w-full rounded-sm object-cover" data-testid="circle-image" />
        <figcaption className="font-mono-plex mt-6 text-[11px] uppercase tracking-[0.14em] text-[#a59f93]" data-testid="circle-caption">With Dion, Smitty and Darius at an inner circle event</figcaption>
      </figure>
    </div>
    <DariusBlock />
  </Section>
);
